// src/api/config.js

export function resolveBase(serviceName) {
  const cfg = typeof window !== "undefined" ? window.__LOAF_CFG : undefined;

  // Check for service-specific config first
  if (cfg && cfg[serviceName] !== undefined && cfg[serviceName] !== "") {
    return cfg[serviceName];
  }

  // Check environment variables
  const envVar = `REACT_APP_${serviceName.toUpperCase()}_API`;
  const envValue = process.env[envVar];
  if (envValue) return envValue;

  // Fallback for demo service to use lock config/env
  if (serviceName === "demo") {
    if (cfg && cfg.lock !== undefined && cfg.lock !== "") {
      return cfg.lock;
    }
    return process.env.REACT_APP_LOCK_API || "";
  }

  return "";
}
